import React, { Component } from 'react';
import { Table, Input } from 'antd';
import { connect } from 'dva';
import { parse } from 'qs';
import Container from '../../../../../components/Container';

// import BreadNav from '@/components/BreadNav/BreadNav';
// import { getCurrentBreadCrumbs } from '@/utils/utils';
import styles from './index.less';

const { Search } = Input;

@connect(({ tagUsers }) => ({
  ...tagUsers,
}))
class TagUsers extends Component {
  constructor(props) {
    super(props);

    const query = parse(window.location.search.split('?').pop());
    const { currentTagId, currentTagName } = query;

    // 面包屑
    // const breadcrumb = getCurrentBreadCrumbs({
    //   currentUrl: {
    //     context: currentTagName,
    //     path: `/countyContacts/tagUsers${window.location.search}`,
    //   },
    //   isTop: false,
    //   storekey: 'countyManagementCenterBreadcrumb',
    // });

    const columns = [
      {
        title: '组织名称',
        dataIndex: 'orgName',
        width: '50%',
      },
      {
        title: '姓名',
        dataIndex: 'userName',
        width: '50%',
      },
    ];

    this.state = {
      // breadcrumb,
      currentPage: 1,
      pageSize: 20,
      columns,
      currentTagId,
      currentTagType: 0, // 系统标签类型
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList = (searchField = null) => {
    const { dispatch } = this.props;
    const { currentTagId, currentPage, pageSize, currentTagType } = this.state;
    dispatch({
      type: 'tagUsers/fetchList',
      payload: {
        type: currentTagType,
        name: searchField,
        tagId: currentTagId,
        page: currentPage,
        pageSize,
      },
    });
  };

  handleSearch = val => {
    const { pageSize } = this.state;
    if (!val && !val.trim().length) {
      this.handleChangePagination(1, pageSize, this.getList);
    } else {
      this.handleChangePagination(1, pageSize, () => this.getList(val));
    }
  };

  handleChangeSize = (current, pageSize) => {
    this.setState(
      {
        currentPage: current,
        pageSize,
      },
      () => {
        this.getList();
      }
    );
  };

  handleChangePagination = (page, pageSize, callback) => {
    this.setState(
      {
        currentPage: page,
        pageSize,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        } else {
          this.getList();
        }
      }
    );
  };

  renderTable = () => {
    const { dataSource, totalElements } = this.props;
    const { columns, currentPage } = this.state;
    const tableProps = {
      rowKey: 'id',
      columns,
      dataSource,
      scroll: { y: 560 },
      pagination: {
        total: totalElements,
        // showTotal: () => <span>{`共${totalElements}条`}</span>,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['20', '50', '100', '200'],
        current: currentPage,
        defaultPageSize: 20,
        onChange: this.handleChangePagination,
        onShowSizeChange: this.handleChangeSize,
      },
    };

    if (totalElements > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${totalElements} 条记录 第 ${currentPage} 页`}</div>
      );
    }
    return (
      <div className="table-wrap">
        <Table {...tableProps} />
      </div>
    );
  };

  render() {
    // const { breadcrumb } = this.state;
    return (
      <Container breStates={!0} version={2} defaultPadding>
        <div className={styles.tagUsers}>
          {/* <BreadNav key="breadNav" dataSource={breadcrumb} /> */}

          <div className="container">
            <div className="header">
              <Search
                style={{ width: 300 }}
                placeholder="搜索姓名、组织名称"
                onSearch={this.handleSearch}
              />
            </div>
            {this.renderTable()}
          </div>
        </div>
      </Container>
    );
  }
}

export default TagUsers;
